<template>
  <TextContainer
    :src="src"
    v-bind:content="content"
    v-bind:id="id"
    v-bind:orientation="orientation"
    v-bind:title="title"
    v-bind:imageFooter="imageFooter"
    v-bind:highlightedImage="highlightedImage"
    v-on:showmodal="$emit('showmodal')"
  />
</template>

<script>
import TextContainer from "./TextContainer";
export default {
  name: "BigTextContainer",
  components: {
    TextContainer
  },
  props: {
    id: Number,
    title: String,
    content: String,
    orientation: Boolean,
    src: String,
    imageFooter: String,
    highlightedImage: Boolean
  }
};
</script>

<style lang="less" scoped>
.text-container {
  min-height: 450px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BigTextContainer.vue